import { render, staticRenderFns } from "./DelLocation.vue?vue&type=template&id=2526c659"
import script from "./DelLocation.vue?vue&type=script&lang=js"
export * from "./DelLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports